<div class="notification-list-flt-content">
  <span class="notification-list-filter-txt">Filter By: </span>
  <one-filtering-chip    
  [list]="typeList"
  [placeholder]="typePlaceholder"
  [formControl]="typeFormControl"
  [width]="width">
  </one-filtering-chip>
  <one-filtering-chip    
    [list]="statusList"
    [placeholder]="statusPlaceholder"
    [formControl]="statusFormControl"
    [width]="widthStatus">
  </one-filtering-chip>
  <one-filtering-chip    
  [list]="countryList"
  [placeholder]="countryPlaceholder"
  [formControl]="countryFormControl"
  [width]="widthCountry">
  </one-filtering-chip>
  <button *ngIf="isClearVis"
  class="button-box"  (click)="clear()" mat-stroked-button one-button-rounded one-secondary-button>
    Clear
  </button>
</div>
